import { useEffect } from 'react';
import { Alert } from './Alert';
import { AlertType } from './types';

export interface TemporalAlertProps {
	show: boolean;
	type: AlertType;
	message: string;
    timeInMs?: number;
	onClose?: () => void;
}

export function TemporalAlert({ show, type, message, timeInMs, onClose }: Readonly<TemporalAlertProps>) {

	useEffect(() => {
		if (show && timeInMs) {
			setTimeout(() => {
				if (onClose) {
					onClose();
				}
			}, timeInMs);
		}
	}, [show, timeInMs]);

	return (
		<>
			{show && (
				<Alert type={type} onClose={onClose} message={message}/>
			)}
		</>
	);
}